module.exports = __webpack_public_path__ + "img/ai-avator.ecb15a1b.png";